<trust-manager
  (certificateImported)="notify($event)"
  (certificateUpdated)="notify($event)"
  (certificateDeleted)="notify($event)">
</trust-manager>
